export const environment = {
    production: false,
    platformApiUrl: 'https://uslegalization-platform.efrx.com/api',
    fallbackDomain: 'saudieapostille.efrx.com',
    fedexApiUrl: 'https://fedexapis.forfastservice.com',
    isTesting: true,
    clientKey: "63xd6yzs9GU5UwYhx979683HX3H9HdW6JKd4dWtcGsEYg2QQm4F766vnN9jxxPHW",
    apiLoginID: "4V2v5Z3az",
    acceptJSLink: 'https://jstest.authorize.net/v3/AcceptUI.js'
};
